import {format, parseISO, getMonth, getYear, addMonths, differenceInCalendarDays} from 'date-fns'

import {DATE_PATTERN} from '../constants/dates'
import {DatePattern} from '../types'

const getDateObj = (date: string | Date) =>
  date instanceof Date ? date : parseISO(date)

export const formatDate = (
  date: string | Date,
  key: DatePattern = 'first'
): string => {
  return format(getDateObj(date), DATE_PATTERN[key])
}

export const isSameYearMonth = (
  first: string | Date,
  second: string | Date
): boolean => {
  const firstDate = getDateObj(first)
  const secondDate = getDateObj(second)
  return (
    getYear(firstDate) === getYear(secondDate) &&
    getMonth(firstDate) === getMonth(secondDate)
  )
}

export const arrayFromMonthsCount = (count: number, startDate: Date): Date[] =>
  new Array(count).fill(null).map((_, index) => addMonths(startDate, index))


/**
 * 日期算头算尾 1号 - 2号，算两天的天数
 * @param to 
 * @param form 
 * @returns 
 */
export const _differenceInCalendarDays = (dateLeft: Date | number, dateRight: Date | number) => {
  return differenceInCalendarDays(dateLeft, dateRight) + 1;
}